module.exports = __webpack_public_path__ + "static/media/feedbackUnderReview.2caef5ba.svg";